import YouTubePlayer from 'youtube-player';

export default {
  init() {

  },
  finalize() {
    // video blocks
    if ($('.video-item').length > 0) {
      $('.video-item').each(function() {
        const $this_ = $(this);
        const $ytWrap = $this_.find('.yt-player');
        const wrapId = $ytWrap.prop('id');
        const ytId = $ytWrap.data('yt-id');

        let player = YouTubePlayer(wrapId, {
          videoId: ytId,
          playerVars: {
            autoplay: 0,
            controls: 1,
            loop: 0,
          },
        });

        $this_.find('.wrap-splash').on('click', function() {
          $this_.find('.wrap-splash').hide();
          player.playVideo();
          player.unMute();
        });

        player.on('stateChange', function(e) {
          if (e.data == 0) {
            // video has ended
            $this_.find('.wrap-splash').show();
          }
        });
      });
    }

    // faqs
    if ($('.faq-question').length > 0) {
      $('.faq-question').each(function() {
        $(this).find('.question-heading').on('click', function() {
          const $question = $(this).parent();

          $('.faq-question').each(function() {
            if ($question.get()[0] != $(this).get()[0]) {
              $(this).removeClass('question-open');
              $(this).find('.question-content').stop().slideUp(250);
            }
          });

          $question.find('.question-content').stop().slideToggle(250);
          $question.toggleClass('question-open');
        });
      });
    }

    // local housing officer triggers
    function runHousingTriggers(query) {
      let $triggerItem = null;

      $('.housing-triggers-results-wrap .creo-trigger-parameter').each(function() {
        // hide all results
        $(this).addClass('d-none');

        if ($triggerItem == null && query.length > 0) {

          // check if query matches any of the inputs
          const inputs = $(this).data('input');

          if (inputs) {

            let result = inputs.filter(item => {
              return item.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });

            if (result.length > 0) {
              // result must be within 5 characters to be acceptable
              let acceptable = false;

              result.forEach((item) => {
                if (Math.abs(item.length - query.length) < 5) {
                  acceptable = true;
                }
              });

              if (acceptable) {
                $triggerItem = $(this);
              }

            }
          }

        }

      });

      if ($triggerItem == null) {
        // not found
        $('.housing-triggers-results-wrap .creo-trigger-parameter.parameter-not-found').removeClass('d-none'); 
      } else {
        // found, display the trigger
        $triggerItem.removeClass('d-none');
      }
    }

    if ($('#housing-officer-search-btn').length > 0) {
      $('#housing-officer-search-btn').on('click', function() {
        runHousingTriggers($('[name="housing-officer-address"]').val());
      });

      $('[name="housing-officer-address"]').on('keydown', function(e) {
        if (e.keyCode == 13) {
          const query = $(this).val();
          runHousingTriggers(query);
        }
      })
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-flexible-default.js